



































import RemoveIcon from '@/components/AvatarBuilderUI/TraitPreviews/RemoveIcon.vue';
import { Prop, Component, Vue, Ref } from 'vue-property-decorator';
import Blizzard from '@/services/Blizzard';

@Component({
  components: {
    RemoveIcon,
  },
})
export default class FacialFeatureTraitPreview extends Vue {
  @Prop(String) readonly previewSrc: string | undefined;
  @Prop(String) readonly previewSrcSecond: string | undefined;
  @Prop(String) readonly option: string | undefined;
  @Prop(String) readonly categoryKey: string | undefined;
  @Prop(Boolean) readonly flipSecond: boolean | undefined;
  @Prop(Boolean) readonly tabNavigationEnabled: boolean | undefined;
  @Ref('trait') readonly trait: HTMLImageElement | undefined;
  @Ref('traitSec') readonly traitSec: HTMLImageElement | undefined;

  get errorImage(): string {
    return require('@/assets/reload_failed.png');
  }
  onLoadEnd(): void {
    Blizzard.recordTraitPreviewLoad(false);
  }
  onError(): void {
    Blizzard.recordTraitPreviewLoad(true);
    if (this.$refs && this.trait) {
      this.trait.src = this.errorImage;
    }
    if (this.$refs && this.traitSec) {
      this.traitSec.src = this.errorImage;
    }
  }
  onClick(): void {
    if (
      (this.$refs && this.option !== '-1' && this.trait && this.trait.src === this.errorImage) ||
      (this.traitSec && this.traitSec.src === this.errorImage)
    ) {
      // retry loading all unloaded preview images in the grid when user clicks
      // on refresh icon
      this.$parent.$emit('reload-category-grid');
    } else {
      this.$emit('on-select-option');
    }
  }

  get facialFeatureImgStyle() {
    if (
      this.categoryKey === 'browring_left' ||
      this.categoryKey === 'browring_right' ||
      this.categoryKey === 'mouthring' ||
      this.categoryKey === 'tonguering'
    ) {
      return {
        width: '55%',
      };
    }
    return {
      width: '35%',
    };
  }
}
